import { graphql } from "@/gql";

export const deleteStripePaymentMethodMutation = graphql(`
  mutation DeleteStripePaymentMethod($id: ID!) {
    deleteStripePaymentMethod(id: $id) {
      id
    }
  }
`);
